import * as React from "react";
import { Avatar as MaterialAvatar, AvatarProps } from "@mui/material";

interface ExtendedAvatarProps extends AvatarProps {
    color?: "red" | "orange" | "yellow" | "green" | "blue" | "darkblue";
}

const Avatar = (props: ExtendedAvatarProps) => <MaterialAvatar className={`${props?.color}`} {...props} />;

export default Avatar;